import React from 'react'
import '../../App.css'

export default function About() {
  return (
    <div className="about">
      <div className="about-card">
        <p>DJ Melech (known off the decks as Cyrus) is a resident at London institutions Chiltern Firehouse, CoOc, Nikita and Gallery. For over 15 years, he has been a fixture of the London scene, playing both clubs and private parties across the UK and Europe.</p>  
        <p>As the founder of DRM RLL PLS, he hosted room 2 at Bugged Out alongside acts such as Tiga, Basement Jaxx and Flying Lotus, brought the party to Bestival, and ran a Soho Radio show from 2018–2020. In 2025, he returned to the airwaves with guest appearances on London’s Voices Radio.</p>  
        <p>Known for digging deep into both fresh cuts and forgotten gems, DJ Melech weaves underground house, disco, techno and his own edits into sets that feel timeless yet unpredictable. Every performance is crafted to move the floor in a way that is uniquely his own.</p>
      </div>
    </div>
  ) 
}